export enum InvoiceAccountingStatus {
  Empty = 1,
  Sent = 2,
  Corrected = 3,
  Canceled = 4,
  AwaitingCorrection = 5,
}
